import type { VatCodeDto } from "../../types/VatCodeDto";
import type { VatCodeEntity } from "../../types/VatCodeEntity";

export const VatCodeEntityToDto = ({ vatValues, ...rest }: Readonly<VatCodeEntity>): VatCodeDto => {
    const newVatValues = vatValues?.map(({ rowId: _rowId, ...vatValue }) => vatValue);

    return { ...rest, vatValues: newVatValues };
};
